
export const styles = theme => ({
    root: {
        marginTop: theme.spacing(2),
        padding : theme.spacing(3),
        width : '100%',
        boxSizing: 'border-box'
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom : '8px',
    },   
    iconCard: {
        width: '5rem'
    }
});